import { useTextReply } from "../context";
import { DealerPhoneValidationAlert } from "./reply-alerts";

/**
 * Centralized container for pre-interaction blocking alerts.
 * Renders above the channel selector and reply controls so that
 * blocking states are prominent before the user attempts to interact.
 */
export function ReplyAlertsTopContainer() {
  const { isPhoneValidationBlocking, selectedDealerPhoneInformation } =
    useTextReply();

  return (
    <>
      {/* Dealer Phone Validation Alert (TEXT only, flag-gated) */}
      {isPhoneValidationBlocking && (
        <DealerPhoneValidationAlert
          campaignApproved={
            selectedDealerPhoneInformation.validation.campaignApproved
          }
          canProceed={selectedDealerPhoneInformation.validation.canProceed}
          isPhoneNumberReady={
            selectedDealerPhoneInformation.validation.isPhoneNumberReady
          }
        />
      )}
    </>
  );
}
